import {Load} from "./Load";
import {History} from "./History";
import {Basic} from "./Basic";
import {Display} from "./Display";

export class Shop
{
    constructor()
    {
        const cartJson = localStorage.getItem('em-shopping-cart');
        this.cart = cartJson ? JSON.parse(cartJson) : {};
        this.cartContainer = '';
        this.cartHandle = '';

        if(Object.keys(this.cart).length)
        {
            this.build_cart();
            this.update_cart(true);
        }
    }

    _process(el)
    {
        let li = el.closest('.w__shop--cart-item');

        switch(el.dataset.action)
        {
            case 'add':
                this.add_toCart(el)
                break;

            case 'checkout':
                this.load_checkout('cart');
                break;

            case 'checkout-address':
                this.load_checkout('address');
                break;

            case 'checkout-count-change':
                let value = parseInt(el.value);
                if(isNaN(value) || value < 1)
                {
                    value = 1;
                }
                else if(value > 9)
                {
                    value = 9;
                }

                // update cart item
                this.cart[el.dataset.typeId][el.dataset.itemId].count = value;

                // update input in interactive cart
                li = this.cartContainer.querySelector('.w__shop--cart-item[data-type-id="' +
                    el.dataset.typeId + '"][data-item-id="' + el.dataset.itemId + '"]');
                li.querySelector('.w__input--number').value =
                    this.cart[el.dataset.typeId][el.dataset.itemId].count;
                this.update_cart();

                // reload checkout
                this.load_checkout('cart',true);
                break;

            case 'checkout-remove':
                // update input in interactive cart
                li = this.cartContainer.querySelector('.w__shop--cart-item[data-type-id="' +
                    el.dataset.typeId + '"][data-item-id="' + el.dataset.itemId + '"]');
                this.remove_fromCart(li);

                // reload checkout
                this.load_checkout('cart',true);
                break;

            case 'confirmed':
                if(!el.classList.contains('mod--inactive'))
                {
                    el.classList.add('mod--inactive');
                    this.load_checkout('confirmed', true, el.dataset.verify);
                    this.destroy_cart();
                }
                break;

            case 'minus':
                if(this.cart[li.dataset.typeId][li.dataset.itemId].count > 0)
                {
                    this.cart[li.dataset.typeId][li.dataset.itemId].count--;
                    if(this.cart[li.dataset.typeId][li.dataset.itemId].count === 0)
                    {
                        this.remove_fromCart(li);
                    }
                    else
                    {
                        li.querySelector('.w__input--number').value =
                            this.cart[li.dataset.typeId][li.dataset.itemId].count;
                        this.update_cart();
                    }
                }
                break;

            case 'plus':
                if(this.cart[li.dataset.typeId][li.dataset.itemId].count < 9)
                {
                    this.cart[li.dataset.typeId][li.dataset.itemId].count++;
                    li.querySelector('.w__input--number').value =
                        this.cart[li.dataset.typeId][li.dataset.itemId].count;
                    this.update_cart();
                }
                break;

            case 'remove':
                this.remove_fromCart(li);
                break;

            case 'remove-all':
                this.destroy_cart();
                break;

            case 'toggle-cart':
                this.cartContainer.classList.toggle('active');
                this.cartContainer.classList.contains('active')
                    ? this.cartContainer.classList.add('mod--close')
                    : this.cartContainer.classList.remove('mod--close');
                break;

            case 'address':
            case 'user-login':
            case 'user-logout':
            case 'user-profile':
                this.load_checkout(el.dataset.action, (el.dataset.action === 'user-logout'));
                break;
        }
    }

    add_toCart(el)
    {
        let imgClone;

        if(el.dataset.typeId && el.dataset.itemId)
        {
            if(!this.cartContainer)
            {
                this.build_cart();
            }

            if(!(this.cart[el.dataset.typeId] &&
                 this.cart[el.dataset.typeId][el.dataset.itemId]))
            {
                const tile = el.closest('.w__tile--shop'),
                      img = tile.querySelector('.w__tile--shop-image'),
                      imgInfo = img.getBoundingClientRect();
                imgClone = img.cloneNode();

                if(!this.cart[el.dataset.typeId])
                {
                    this.cart[el.dataset.typeId] = {};
                }
                this.cart[el.dataset.typeId][el.dataset.itemId] = {
                    count: 1,
                    type: el.dataset.type,
                    title: el.dataset.title,
                    price: parseFloat(el.dataset.price),
                    imgSrc: img.src
                }

                imgClone.classList.add('mod--clone');
                imgClone.style.top = imgInfo['top'].toString() + 'px';
                imgClone.style.left = imgInfo['left'].toString() + 'px';
                imgClone.style.height = imgInfo['height'].toString() + 'px';
                imgClone.style.width = imgInfo['width'].toString() + 'px';
                document.body.appendChild(imgClone);
                imgClone.offsetHeight;
                imgClone.classList.add('mod--move');

                this.add_itemToCart(el.dataset.typeId, el.dataset.itemId);
            }
        }

        setTimeout(() => {
            if(imgClone)
            {
                imgClone.remove();
            }
            this.cartContainer.classList.add('active');
            setTimeout(() => {
                this.cartContainer.classList.remove('active');
                this.cartContainer.classList.remove('mod--close');
            },250);
        }, 500);

        this.update_cart();
    }

    add_itemToCart(typeId, itemId)
    {
        const el = this.cart[typeId][itemId];

        const item = document.createElement('li');
        item.classList.add('w__shop--cart-item');
        item.dataset.typeId = typeId;
        item.dataset.itemId = itemId;

        const itemUp = document.createElement('button');
        itemUp.className = 'w__button w__js-button w__blur--button w__shop--change-count';
        itemUp.dataset.f = 'shop-action';
        itemUp.dataset.action = 'plus';
        itemUp.textContent = '+';

        const itemCount = document.createElement('input');
        itemCount.classList.add('w__input');
        itemCount.classList.add('w__input--number');
        itemCount.value = el.count;

        const itemDown = document.createElement('button');
        itemDown.className = 'w__button w__js-button w__blur--button w__shop--change-count';
        itemDown.dataset.f = 'shop-action';
        itemDown.dataset.action = 'minus';
        itemDown.textContent = '-';

        const itemChange = document.createElement('div');
        itemChange.classList.add('w__shop--change-container');
        itemChange.appendChild(itemUp);
        itemChange.appendChild(itemDown);

        const itemCountContainer = document.createElement('div');
        itemCountContainer.classList.add('w__shop--item-count');
        itemCountContainer.appendChild(itemCount);
        itemCountContainer.appendChild(itemChange);

        const itemImg = new Image();
        itemImg.src = el.imgSrc;
        itemImg.alt = '';
        itemImg.classList.add('w__shop--cart-image');

        const itemTitle = document.createElement('p');
        itemTitle.classList.add('w__shop--cart-title');
        itemTitle.innerHTML = '<b>' + (!el.type || el.type === 'Merchandise' ? '' : el.type + ': ') + el.title + '</b>' +
                              'EUR ' + el.price;

        item.appendChild(itemCountContainer);
        item.appendChild(itemImg);
        item.appendChild(itemTitle);

        this.cartInner.appendChild(item);
    }

    build_cart()
    {
        this.cartContainer = document.createElement('div');
        this.cartContainer.className = 'w__shop--cart-container w__no-select';

        this.cartHandle = document.createElement('button');
        this.cartHandle.classList.add('w__button');
        this.cartHandle.classList.add('w__shop--cart-handle');
        this.cartHandle.classList.add('w__js-button');
        this.cartHandle.dataset.f = 'shop-action';
        this.cartHandle.dataset.action = 'toggle-cart';
        this.cartHandle.dataset.count = '1';
        this.cartHandle.title = (Basic.lang === 'de') ? 'Einkaufswagen öffnen/schließen' : 'Open/close cart';

        this.cartInner = document.createElement('ul');
        this.cartInner.classList.add('w__shop--cart');

        const buttonP = document.createElement('p');
        buttonP.classList.add('w__shop--cart-button-container');

        const button = document.createElement('button');
        button.classList.add('w__button');
        button.classList.add('w__shop--checkout');
        button.classList.add('w__js-button');
        button.classList.add('w__hover--color-bg');
        button.dataset.f = 'shop-action';
        button.dataset.action = 'checkout';
        button.textContent = (Basic.lang === 'de') ? 'Bestellen' : 'Checkout';
        const arrow = document.createElement('span');
        arrow.textContent = '⟶ ';
        arrow.classList.add('w__500');
        button.insertAdjacentElement('afterbegin', arrow);
        buttonP.appendChild(button);

        const reset = document.createElement('button');
        reset.classList.add('w__button');
        reset.classList.add('w__shop--checkout');
        reset.classList.add('w__js-button');
        reset.classList.add('w__hover--color-bg');
        reset.dataset.f = 'shop-action';
        reset.dataset.action = 'remove-all';
        reset.textContent = (Basic.lang === 'de') ? 'Leeren' : 'Reset';
        const x = document.createElement('span');
        x.textContent = 'X ';
        x.classList.add('w__500');
        reset.insertAdjacentElement('afterbegin', x);
        buttonP.appendChild(reset);

        this.cartContainer.appendChild(this.cartHandle);
        this.cartContainer.appendChild(this.cartInner);
        this.cartContainer.appendChild(buttonP);

        document.body.appendChild(this.cartContainer);
    }

    close_details(el)
    {
        const myTitles = document.title.split(' / ');
        while(myTitles.length > 3)
        {
            myTitles.shift();
        }
        document.title = myTitles.join(' / ');
        History.push_url(el.href,true);
        el.closest('.w__tile--shop').remove();
        const selectedEl = document.getElementById('w--temp-active');
        if(selectedEl)
        {
            selectedEl.removeAttribute('style');
        }
    }

    load_details(el)
    {
        const container = document.getElementById('w--load-into');
        Load.post({
            f: el.dataset.f,
            url: el.href
        }).then(r => {
            // selected item
            const selectedEl = el.closest('.w__tile--shop');

            // remove details item if present
            let detailsEl = container.querySelector('.w__tile--shop.active');
            if(detailsEl)
            {
                detailsEl.remove();
            }

            // create new details item
            container.insertAdjacentHTML('beforeend', r['html']);
            detailsEl = container.querySelector('.w__tile--shop.active');
            if(detailsEl)
            {
                document.title = r['page_title'];
                switch(Display.device)
                {
                    case 'smartphone':
                    case 'tablet':
                        // grid-row must be determined when not in default layout (=desktop)
                        const items = el.closest('.w__module--shop').querySelectorAll('.w__tile--shop'),
                              add = (Display.device === 'smartphone') ? 1 : .5;
                        let row = 1;
                        for(let i=0; i<items.length; i++)
                        {
                            if(selectedEl === items[i])
                            {
                                if(Display.device === 'smartphone')
                                {
                                    selectedEl.style.cssText = 'grid-row:' + Math.floor(row).toString() + '!important';
                                    selectedEl.id = 'w--temp-active';
                                }
                                detailsEl.style.cssText = 'grid-row:' + Math.floor(row).toString() + '!important';
                                break;
                            }
                            else
                            {
                                row += add;
                            }
                        }
                        break;

                    default:
                        detailsEl.style.gridRow = selectedEl.style.gridRow;
                }
                detailsEl.scrollIntoView(true);
                History.push_url(el.href,true);
                Basic.update_languageMenus(r);
            }
        }).catch(r => {
            console.error(r, el.href);
        });
    }

    load_checkout(target, noHistory, verify)
    {
        const url = Basic.base + Basic.lang + '/checkout/' + target,
              data = {
                  f: 'load',
                  url: url
              };

        if(verify)
        {
            data.url += '/' + verify;
        }

        switch(target)
        {
            case 'cart':
                data.cart = Basic.shop.cart
                break;
        }

        Load.post(data).then(r => {
            Basic.update_page(r, noHistory ? '' : (r['new-url'] ? r['new-url'] : url));
        }).catch(error => {
            console.error(error);
        });
    }

    destroy_cart()
    {
        this.cart = {};
        if(this.cartContainer)
        {
            this.cartContainer.remove();
            this.cartContainer = '';
            this.cartHandle = '';
        }
        localStorage.removeItem('em-shopping-cart');
    }

    remove_fromCart(el)
    {
        if(el)
        {
            delete(this.cart[el.dataset.typeId][el.dataset.itemId]);
            el.remove();

            if(Object.keys(this.cart[el.dataset.typeId]).length === 0)
            {
                delete(this.cart[el.dataset.typeId]);
                if(Object.keys(this.cart).length === 0)
                {
                    this.cartContainer.remove();
                    this.cartContainer = '';
                }
            }

            this.update_cart();
        }
    }

    update_cart(addItems)
    {
        let count = 0;

        for(const [typeId, categories={}] of Object.entries(this.cart))
        {
            for(const [itemId, item] of Object.entries(categories))
            {
                count += item.count;
                if(addItems === true)
                {
                    this.add_itemToCart(typeId, itemId);
                }
            }
        }

        this.cartHandle.dataset.count = count.toString();
        localStorage.setItem('em-shopping-cart', JSON.stringify(this.cart));
    }
}